import { InterfaceElement } from "../../asd/asd-properties/asd-ie/asd-interfaceElement";
import { FormState } from "../../form/form-properties/form-state";

export class AccessDuty {
    
    public static readonly UpdateIE = 'UpdateInterfaceElementProperties';
    public static readonly RefreshIE = 'RefreshInterfaceElementProperties';
}

export class AccessParameter {
    TemplateID: string ; 
    DesignDocumentIEList: InterfaceElement[]; 
    FormState: FormState
}